import axiosInstance from "../config/axiosInterceptor";

export async function getSlots() {
  return await axiosInstance.get("/api/Slots");
}

export async function getSlotById(id) {
  return await axiosInstance.get(`/api/Slots/${id}`);
}

export async function postSlots(slotData) {
  const requestData = {
    idslotTable: 0,
    slotDefinitionTable_name: "string",
    stockTable_name: "string",
    ...slotData,
  };

  return await axiosInstance.post("/api/Slots", requestData);
}

export async function putSlots(slotData) {
  const requestData = {
    idslotTable: slotData.idslotTable,
    slotDefinitionTable_name: "string",
    stockTable_name: "string",
    ...slotData,
  };

  return await axiosInstance.put("/api/Slots", requestData);
}

export async function deleteSlots(idslotTable) {
  return await axiosInstance.delete(`/api/Slots/${idslotTable}`);
}
